import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, SelectItem } from 'primeng/components/common/api';
import { roleMS } from '../../../models/roleMS.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { ApplicationService } from '../../../services/application/applications.service';
import { AuthService } from '../../../services/user/auth.service';
import { RoleMSService } from '../../../services/utils/roleMS.service';

@Component({
  providers: [],
  selector: 'app-roles-application',
  templateUrl: './rolesApplication.component.html'
})

export class RolesApplicationComponent implements OnInit {

  customButtons: DataTableCustomButton[];
  roleMSTitles: DataTableField[];
  selectedRoleMS: roleMS = null;
  selectedRoleEdit: roleMS = null;
  showUsers = false;
  showPermissions = false;
  newDataAvailable = false;
  paginationType = KontableComponent.ClientPagination;
  customFilter = KontableComponent.CustomFilter;
  showDetail = false;
  applicationDropdown: SelectItem[];
  mainTable = true;
  modalTitle = '';
  labels = {}

  constructor (
    private translate: TranslateService,
    private authService: AuthService,
    public srvRoleMS: RoleMSService,
    private srvDataTable: DataTableService,
    private srvNotify: MessageService,
    private srvApplication: ApplicationService
  ) {
    this.translate.get([
      'common.role',
      'common.applications',
      'roleMS.users',
      'roleMS.permissions',
      'roleMS.add_title',
      'roleMS.edit_title'
    ]).subscribe((res) => {

      this.labels['add_title'] = res['roleMS.add_title'];
      this.labels['edit_title'] = res['roleMS.edit_title'];

      this.roleMSTitles = [
        {id: 'id', label: '#'},
        {id: 'description', label: res['common.role']},
        {id: 'application', label: res['common.applications']}
      ];
      this.customButtons = [
        {label: res['roleMS.users'], callbackname: 'users', icon: 'fa fa-user', isAlwaysEnabled: false},
        {label: res['roleMS.permissions'], callbackname: 'permissions', icon: 'fa fa-key', isAlwaysEnabled: false}
      ];
    });
      this.applicationDropdown = [{
        value: '',
        label: ''
      }];
      const loggedUser = this.authService.user;
      if (loggedUser.role === 'S') {
        this.srvApplication.getAll().subscribe( res =>
          res.forEach( app => {
            this.applicationDropdown.push({
              value: app.name,
              label: app.name
            });
          })
        )
      } else {
        this.authService.user.enabledUserApps.forEach((userApp) => {
          const item: SelectItem = {
            value: userApp.application_name,
            label: userApp.application_name
          };
          this.applicationDropdown.push(item);
        });
      }
  }

  buildRoleMS($event): roleMS {
    let userApp = this.authService.user.enabledUserApps.find(ua => ua.application_id === $event.applicationId);
    let role: roleMS = {
      applicationId: $event.applicationId,
      description: $event.roleName,
      ms_base_url: userApp.ms_base_url,
      id: this.selectedRoleMS == null ? 0 : this.selectedRoleMS.id,
      application: userApp.application_name
    };
    return role;
  }

  ngOnInit(): void {
    this.reload();
    this.closeDialogDetail();
  }

  reload (): void {
    this.srvRoleMS.getAll(this.authService.user.enabledUserApps);
    this.newDataAvailable = true;
  }

  save(event): void {

    let role = this.buildRoleMS(event);
    if (this.selectedRoleMS == null) {
      this.srvRoleMS.post(role).subscribe(() => {
        this.reload ();
        this.closeDialogDetail();
      });
    } else {
      this.srvRoleMS.put(role).subscribe(() => {
        this.reload ();
        this.closeDialogDetail();
      });
    }
    this.selectedRoleMS = null;
  }

  remove(event): void {
    if (event.applicationId == null) {
      this.translate.get(
        [
          'roleMS.actionUnavailable',
          'roleMS.actionUnavailableDetail'
        ]
      ).subscribe(res => {
        this.srvNotify.add({severity: 'warning', summary: res['roleMS.actionUnavailable'], detail: res['roleMS.actionUnavailableDetail']})
      });

      this.srvDataTable.get('dt_roles').showDetail = false;
      this.reload ();
      return;
    }
    this.selectedRoleMS = event;
    let role = this.buildRoleMS(event);
    this.srvRoleMS.delete(role).subscribe(() => {
        this.reload ();
    });
  }

  customButton(event, callbackName): void {
    this.selectedRoleEdit = event;
    switch (callbackName) {
      case 'users':
        this.showUsers = true;
        this.showPermissions = false;
        this.mainTable = false;
        break;
      case 'permissions':
        this.showUsers = false;
        this.showPermissions = true;
        this.mainTable = false;
        break;
    }
  }

  returnToMain() {
    this.showUsers = false;
    this.showPermissions = false;
    this.mainTable = true;
    this.selectedRoleEdit = null;
  }

  editRole(row): void {
    this.modalTitle = row == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.showDetail = true;
    this.selectedRoleMS = row;
  }

  closeDialogDetail() {
    this.showDetail = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplication.component.ts